import { Mail, Phone, Sparkles } from 'lucide-react';
import { DEALS, type DealTerms } from '@generated/components/dealCatalog';


const PERKS = [
  ['1/8 page ad', 'in the paper for three straight months'],
  ['New Business Section', 'a special section just for neighborhood newcomers'],
  ['We tell your story', 'part of the section introduces and promotes new businesses'],
] as const;

/** Featured "New Business Special" on the Display Advertising page: 3 months of 1/8 page for $150. */
export function NewBusinessDeal({ onClaim }: { onClaim: (d: DealTerms) => void }) {
  return (
    <section className="mb-10 border-4 border-foreground bg-card shadow-[8px_8px_0_hsl(var(--brand-purple))]">
      <div className="grid md:grid-cols-[1fr_260px]">
        <div className="min-w-0 p-5 sm:p-7">
          <div className="inline-flex items-center gap-1.5 border-2 border-foreground bg-[hsl(var(--brand-purple))] text-primary-foreground px-2.5 py-1 text-[11px] font-black uppercase tracking-[0.18em]"><Sparkles className="h-3.5 w-3.5" />Just opened?</div>
          <h3 className="mt-3 font-sans text-3xl font-black uppercase leading-[0.95] tracking-tight text-[hsl(var(--brand-green))] sm:text-5xl">New Business Special</h3>
          <p className="mt-4 max-w-xl text-base leading-relaxed">Welcome to the neighborhood! We know money can be tight when you're first starting out, so we've made it easy to get noticed: <strong>three months of advertising for $150 total.</strong></p>
          <ul className="mt-5 space-y-3">
            {PERKS.map(([t, d], i) => (
              <li key={t} className="flex items-baseline gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center bg-[hsl(var(--brand-purple))] font-sans text-base font-black text-primary-foreground">{i + 1}</span>
                <p className="font-sans text-lg font-bold leading-snug">{t}: <span className="font-semibold text-muted-foreground">{d}</span></p>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col items-center justify-center gap-1 border-t-4 border-foreground bg-[hsl(var(--brand-purple))] p-6 text-center text-primary-foreground md:border-l-4 md:border-t-0">
          <span className="text-xs font-black uppercase tracking-[0.2em]">Three months</span>
          <span className="font-sans text-7xl font-black italic leading-none">$150</span>
          <span className="text-sm font-semibold">total · just $50 a month</span>
          <span className="mt-2 border-2 border-primary-foreground px-2 py-0.5 text-[11px] font-black uppercase tracking-wider">Eighth-page ads</span>
        </div>
      </div>
      <div className="flex flex-col gap-3 border-t-4 border-foreground p-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm font-semibold">Ads also run on our website. Free ad design help included.</p>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={() => { const d = DEALS.find((x) => x.key === "new-business"); if (d) onClaim(d); }} className="inline-flex min-h-11 items-center gap-2 bg-[hsl(var(--brand-green))] px-4 text-sm font-bold text-primary-foreground hover:opacity-90"><Mail className="h-4 w-4" />Claim this deal</button>
          <a href="tel:9176529128" className="inline-flex min-h-11 items-center gap-2 border-2 border-foreground px-4 text-sm font-bold"><Phone className="h-4 w-4" />Call 917-652-9128</a>
        </div>
      </div>
    </section>
  );
}
